<div [class.main-control]="autoplay" *ngIf="audioElement">

  <mat-icon 
    name="mute-toogle-on"
    [matTooltip]="muteTooltip"
    *ngIf="!audioElement.muted && autoplay" 
    [class.question-icon-btn]="!autoplay"
    [class.main-control-icon]="autoplay"
    (click)="toggleMute()" 
    color="primary" 
    class="audio-control-icon">
    volume_up
  </mat-icon>
  <mat-icon 
    name="mute-toogle-off"  
    [matTooltip]="unmuteTooltip"
    *ngIf="audioElement.muted && autoplay" 
    [class.question-icon-btn]="!autoplay"
    [class.main-control-icon]="autoplay"
    (click)="toggleMute()" 
    color="primary" 
    class="audio-control-icon">
    volume_off
  </mat-icon>

  <ng-container *ngIf="!audioElement.muted">
    <ng-container *ngIf="audioElement?.paused || audioElement?.ended || (queued && !isPlaying); else pauseElement" >
      <mat-icon 
        name="play-button"      
        [matTooltip]="playTooltip"
        [class.question-icon-btn]="!autoplay"
        [class.main-control-icon]="autoplay"
        (click)="playAudio(src)" 
        color="primary" 
        class="audio-control-icon">
        play_circle_outline
      </mat-icon>
    </ng-container>
    <ng-template #pauseElement>
      <mat-icon 
        name="pause-button"      
        [matTooltip]="pauseTooltip"
        [class.question-icon-btn]="!autoplay"
        [class.main-control-icon]="autoplay"
        (click)="pauseAudio()" 
        color="accent" 
        class="audio-control-icon">
        pause_circle_outline
      </mat-icon>
    </ng-template>
    <mat-icon 
      name="replay-button"      
      class="audio-control-icon"
      [matTooltip]="replayTooltip"
      *ngIf="audioElement.currentTime > 2 || queued"
      color="accent" 
      (click)="paused = false; playAudio(src, true)"
      [class.question-icon-btn]="!autoplay"
      [class.main-control-icon]="autoplay"
      >replay</mat-icon>
  </ng-container>
</div>
